// last update: 2:39 PM
const buildTheme = ({
  isMobile,
  color,
  primaryColor,
  secondaryColor,
  primaryTextColor,
  secondaryTextColor,
  orangeBackgroundColor,
  dropdownBorderStyle,
  borderColor,
  itemBorderStyle,
  timeText,
  tabLabelAfterStyle,
  dropdownWidth,
  headerBorderBottom,
}: any) => {
  return {
    bellButton: {
      root: {
        borderRadius: '50%',
        marginLeft: isMobile ? 0 : '10px',
        height: '50px',
        width: '50px',
        svg: {
          color: color,
          fill: 'transparent',

          minWidth: '20px',
          minHeight: '20px',
          width: '24px',
          height: '24px',
        },
      },
      dot: {
        rect: {
          fill: '#ff7d26ff',
          strokeWidth: '0',
          width: '8px',
          height: '8px',
          x: 2,
          y: 8,
        },
      },
    },
    unseenBadge: {
      root: { color: primaryTextColor, background: secondaryColor },
    },
    popover: {
      root: {
        zIndex: -99,
      },
      arrow: {
        backgroundColor: primaryColor,
        borderLeftColor: borderColor,
        borderTopColor: borderColor,
      },
      dropdown: {
        borderRadius: isMobile ? 0 : '16px',
        marginTop: '-15px',
        maxWidth: dropdownWidth,
        display: 'block',
        marginLeft: isMobile ? '-2px' : '24px',
      },
    },
    header: {
      root: {
        backgroundColor: primaryColor,
        '&:hover': { backgroundColor: primaryColor },
        cursor: 'pointer',
        color: primaryColor,
        borderBottom: headerBorderBottom,
        padding: '0 32px',
      },
      cog: { opacity: 1 },
      markAsRead: {
        color: primaryTextColor,
        fontSize: '12px',
        letterSpacing: '0.25px',
        lineHeight: '14px',
      },
      title: {
        color: primaryTextColor,
        fontSize: '16px',
        letterSpacing: '0.5px',
      },
      backButton: {
        color: primaryTextColor,
      },
    },
    layout: {
      root: {
        background: primaryColor,
        maxWidth: dropdownWidth,
      },
    },
    loader: {
      root: {
        stroke: primaryTextColor,
      },
    },
    accordion: {
      item: {
        backgroundColor: secondaryColor,
        ':hover': {
          backgroundColor: secondaryColor,
        },
      },
      content: {
        backgroundColor: secondaryColor,
        borderBottomLeftRadius: '7px',
        borderBottomRightRadius: '7px',
      },
      control: {
        ':hover': {
          backgroundColor: secondaryColor,
        },
        color: primaryTextColor,
        title: {
          color: primaryTextColor,
        },
      },
      chevron: {
        color: primaryTextColor,
        display: 'none',
      },
    },
    notifications: {
      root: {
        '.nc-notifications-list-item': {
          backgroundColor: primaryColor,
          border: 'none',
          margin: 0,
          borderRadius: 0,
          fontSize: '14px',
          lineHeight: isMobile ? '24px' : '21px',
          letterSpacing: '0.5px',
          padding: '16px 20px 16px 28px',
          fontWeight: 'normal',
          gap: '2px',
        },
      },
      listItem: {
        layout: {
          color: primaryTextColor,
          margin: '0 !important',
          gap: '8px',
          'div:has(> .mantine-Avatar-root)': {
            border: 'none',
            width: '20px',
            height: '20px',
            minWidth: '20px',
          },
          '.mantine-Avatar-root': {
            width: '20px',
            height: '20px',
            minWidth: '20px',
          },
          '.mantine-Avatar-image': {
            width: '20px',
            height: '20px',
            minWidth: '20px',
          },
        },
        timestamp: { color: timeText, fontWeight: 'normal' },
        dotsButton: {
          path: {
            display: 'none',
          },
        },
        unread: {
          '::before': {
            background: '#ff7d26ff !important',
            borderRadius: 0,
          },
          boxShadow: 'none',
          padding: '24px, 64px, 24px, 0px',
        },
        buttons: {
          primary: {
            background: 'transparent',
            'text-transform': 'uppercase',
            color: '#ff7d26ff',
            justifyContent: 'left',
            fontWeight: '400',
            fontSize: '14px',
            paddingLeft: 0,
            letterSpacing: '1.25px',
            '&:hover': {
              color: '#ff9b58',
              background: 'transparent',
            },
          },
        },
      },
    },
    actionsMenu: {
      item: { '&:hover': { backgroundColor: secondaryColor } },
      dropdown: {
        backgroundColor: primaryColor,
      },
      arrow: {
        backgroundColor: primaryColor,
        borderTop: '0',
        borderLeft: '0',
      },
    },
    preferences: {
      item: {
        title: { color: primaryTextColor },
        divider: { borderTopColor: primaryColor },
        channels: { color: secondaryTextColor },
        content: {
          icon: { color: primaryTextColor },
          channelLabel: { color: primaryTextColor },
          success: { color: primaryTextColor },
        },
      },
    },
    tabs: {
      tabLabel: {
        '::after': { background: tabLabelAfterStyle },
        ':hover': { color: tabLabelAfterStyle },
        '[data-active]': { color: primaryColor },
      },
      tabsList: { borderBottomColor: primaryColor },
    },
  };
};

export const lightTheme = (isMobile: boolean) => {
  return buildTheme({
    isMobile,
    color: 'black',
    primaryColor: 'white',
    secondaryColor: '#ff7d26ff',
    primaryTextColor: 'black',
    secondaryTextColor: 'white',
    orangeBackgroundColor:
      'linear-gradient(135deg, var(--color-orange-500) 0%, var(--color-orange-600) 100%)',
    dropdownBorderStyle: '1px solid #c4c4c4 !important',
    timeText: '#9a9a9a',
    borderColor: '#c4c4c4',
    itemBorderStyle: '0.5px solid #c4c4c4 !important',
    tabLabelAfterStyle: '#ff7d26ff !important',
    headerBorderBottom: '#ddddddff 1px solid',
  });
};

export const darkTheme = (isMobile: boolean) => {
  return buildTheme({
    isMobile,
    color: 'white',
    primaryColor: '#1C2022',
    secondaryColor: '#ff7d26ff',
    primaryTextColor: 'white',
    secondaryTextColor: 'white',
    orangeBackgroundColor:
      'linear-gradient(135deg, var(--color-orange-500) 0%, var(--color-orange-600) 100%)',
    dropdownBorderStyle: '1px solid #6f80877f !important',
    timeText: '#c4c4c4',
    borderColor: '#c4c4c4',
    itemBorderStyle: '0.5px #9a9a9a solid !important',
    tabLabelAfterStyle: '#ff7d26ff !important',
    headerBorderBottom: '#6f80877f 1px solid',
  });
};
